<script lang="ts">
	import type { PageData } from './$types';
	import PageLoader from '$lib/components/ui/PageLoader.svelte';
	import DynamicImportError from '$lib/components/ui/DynamicImportError.svelte';

	let { data } = $props<{ data: PageData }>();

	let retryCount = $state(0);

	// Dynamically import the appropriate version with retry support
	let marketPromise = $derived.by(() => {
		// Trigger re-import when retryCount changes
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const _retry = retryCount;
		return data.showModern
			? import('../modern/market/+page.svelte')
			: import('../legacy/market/+page.svelte');
	});

	function handleRetry() {
		retryCount++;
	}

	function handleHardRefresh() {
		window.location.reload();
	}
</script>

{#await marketPromise}
	<PageLoader />
{:then MarketComponent}
	<MarketComponent.default {data} />
{:catch error}
	<DynamicImportError
		{error}
		{retryCount}
		onRetry={handleRetry}
		onHardRefresh={handleHardRefresh}
		pageName="Market"
	/>
{/await}
